import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Auth0Provider } from '../AthuO/AuthOwrapper';
import { AppContextData } from '../AppContext';
import { Loader } from '../../components/Loader/Loader';

function OAuthLandingProxy () {
  const { state } = useContext(AppContextData);
  const location = useLocation();
  const navigate = useNavigate();
  const language = require('locale2') || 'en-us';

  // React 18 fix: Prefer navigation state over context state
  // to avoid timing issues. Navigation state is passed directly
  // during navigate() call. Context state is fallback for callbacks.
  const authOConfig =
    location.state?.authTypeResponse || state?.authTypeResponse;

  useEffect(() => {
    if (authOConfig) {
      // eslint-disable-next-line no-console
      console.info('[OAuth] OAuthLanding received config:', {
        source: location.state?.authTypeResponse
          ? 'navigation state'
          : 'context state',
        provider: authOConfig.provider,
        clientId: authOConfig.clientId ? '✓ present' : '✗ missing',
        redirectUri: authOConfig.redirectUri ? '✓ present' : '✗ missing',
        authType: authOConfig.authType
      });
    } else if (!state.isLoading) {
      // eslint-disable-next-line no-console
      console.warn('[OAuth] Config not found, redirecting to home');
      navigate('/', { replace: true });
    }
  }, [authOConfig, state.isLoading, navigate, location.state]);

  if (!authOConfig) {
    // eslint-disable-next-line no-console
    console.info('[OAuth] Waiting for config, showing loader...');
    return <Loader type='fullScreen'/>;
  }

  return (
    <Auth0Provider
      language={language}
      state={location.state}
      domain={''}
      authType={authOConfig}
      client_id={authOConfig.clientId}
      redirect_uri={authOConfig.redirectUri}
    />
  );
}

export const OAuthLanding = OAuthLandingProxy;
